<template>
  <v-content class="pt-0">
    <v-flex xs12 md12>
      <v-form>
        <v-container class="grid-list-md">
          <h1>Zgody</h1>

          <consents-input :termsList="termsList" :model="$schema.termIds" />

          <v-card class="elevation-0 mb-3">
            <v-card-actions class="pb-4 pt-4">
              <v-btn depressed large dark round color="primary" @click="tryToUpdate">Zapisz</v-btn>
            </v-card-actions>
          </v-card>
        </v-container>
      </v-form>
    </v-flex>
  </v-content>
</template>

<script>
import { mapState } from 'vuex';
import { schemaMixin } from '@witkac/vuetify-components';
import { ProfileType } from '@witkac/kartamiejska-shared';
import { consentResource } from '@witkac/kartamiejska-resources';

import ConsentsInput from '@/components/forms/ConsentsInput';
import schema from '@/schemas/consents.schema';
import store from '@/store/store';
import { SessionStorage } from '@/enums/sessionStorage.enum';

export default {
  components: { ConsentsInput },
  mixins: [schemaMixin],
  schema,
  data() {
    return {
      model: {}
    };
  },
  methods: {
    tryToUpdate() {
      if (!this.$schema.$validateAll().length) {
        Promise.all(
          this.model.termIds.map(id =>
            consentResource.add({
              input: {
                accepted: true,
                termsId: id,
                profileId: parseInt(
                  sessionStorage.getItem(SessionStorage.PROFILE_ID)
                )
              }
            })
          )
        )
          .then(() => this.$router.push({ name: 'home' }))
          .catch(err =>
            this.$store.dispatch('notifyError', {
              title:
                'Wystąpił błąd podczas zapisywania zgód. Spróbuj ponownie później.'
            })
          );
      }
    }
  },
  computed: mapState({
    termsList: state => {
      const termIds = acceptedTermsIds();
      return state.terms.current.filter(
        terms => terms.required && !termIds.includes(terms.id)
      );
    }
  }),
  beforeRouteEnter(to, from, next) {
    Promise.all([
      store.dispatch('terms/getCurrent', ProfileType.CLIENT),
      store.dispatch('consents/accepted')
    ]).then(() => next());
  },
  beforeCreate() {
    const termIds = acceptedTermsIds();
    this.$options.external = {
      requiredTerms: this.$store.state.terms.current
        .filter(terms => terms.required && !termIds.includes(terms.id))
        .map(terms => terms.id)
    };
  }
};

function acceptedTermsIds() {
  return store.state.consents.accepted
    .filter(consent => consent.accepted)
    .map(consent => consent.terms.id);
}
</script>

<style>
</style>